import { createContext, useContext, useMemo, useState } from "react";
import type { ReactNode } from "react";

type LayoutContextType = {
  pageRendered: boolean;
  setPageRendered: (value: boolean) => void;
};

const LayoutContext = createContext<LayoutContextType>({
  pageRendered: false,
  setPageRendered: () => {},
});
export const useLayoutContext = () => useContext(LayoutContext);

export const LayoutProvider = ({ children }: { children: ReactNode }) => {
  /**
   * The footer component is rendered by the layout which means that on first open the footer renders by itself until the page content renders which looks janky.
   * `pageRendered` is used to delay the footer rendering until the page is ready.
   */
  const [pageRendered, setPageRendered] = useState(false);

  const value = useMemo(
    () => ({
      pageRendered,
      setPageRendered,
    }),
    [pageRendered],
  );
  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};
